import axios, { AxiosInstance, AxiosError } from 'axios';

// Create axios instance with base configuration
// API_URL is injected by webpack DefinePlugin from .env file
const API_URL = process.env.API_URL || 'http://localhost:3001/api';

// Log the API URL being used (helps debug configuration issues)
console.log('===========================================');
console.log('API Client Configuration:');
console.log('  API_URL:', API_URL);
console.log('  process.env.API_URL:', process.env.API_URL);
console.log('===========================================');

const apiClient: AxiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor: Add JWT token to all requests
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor: Handle errors globally
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // Handle 401 Unauthorized - logout user
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');

      // Only redirect if not already on login page
      if (window.location.pathname !== '/login' && window.location.pathname !== '/register') {
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
